import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = (props) => {
  const { Authentication, component: Component } = props;
  if (Authentication.isAuthenticated) {
    return <Component />;
  }
  return <Navigate to="/" replace />;
};
const mapStateToProps = (store) => ({
  Authentication: store.Authentication,
});
export default connect(mapStateToProps)(ProtectedRoute);

